export default __webpack_public_path__ + "static/media/running.a38ecfa6.png";